// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zCEH","toggleWrap":"styles_toggleWrap__E4cLZ","content":"styles_content__2xlWU","selectAreaCode":"styles_selectAreaCode__LQGyB"};